export default "__VITE_ASSET__DlZ46hQV__"